
import { useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import DemoPageHeader from "@/components/DemoPageHeader";
import DashboardStats from "@/components/dashboard/DashboardStats";
import RecentOrders from "@/components/dashboard/RecentOrders";
import { DEMO_ORDERS, DEMO_PRODUCTS } from "@/utils/demoData";
import { formatRevenue } from "@/utils/currencyFormatter";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Sparkles, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const DemoDashboard = () => {
  // Calculate demo stats from demo data
  const demoStats = {
    totalOrders: DEMO_ORDERS.length,
    totalRevenue: DEMO_ORDERS.reduce((sum, order) => sum + (order.totalAmount || 0), 0),
    totalRevenueByCurrency: { USD: DEMO_ORDERS.reduce((sum, order) => sum + (order.totalAmount || 0), 0) },
    totalProducts: DEMO_PRODUCTS.length,
    totalSales: DEMO_PRODUCTS.reduce((sum, product) => sum + (product.salesCount || 0), 0),
    recentOrders: DEMO_ORDERS.slice(0, 5).map(order => ({
      id: order.receiptId,
      receiptId: order.receiptId,
      customerName: order.customerName,
      productName: order.productName,
      status: order.status,
      totalAmount: order.totalAmount || 0,
      currencyCode: order.currencyCode || 'USD',
      date: order.date
    }))
  };

  return (
    <DashboardLayout>
      <DemoPageHeader
        title="Demo Dashboard"
        description="Experience how your Etsy store data would look in our platform."
      >
        {/* Demo Banner */}
        <Card className="border-blue-200 bg-blue-50 mb-6">
          <CardContent className="p-6">
            <div className="flex items-start gap-4">
              <Sparkles className="h-6 w-6 text-blue-600 mt-1 flex-shrink-0" />
              <div className="flex-1">
                <h3 className="font-semibold text-blue-900 mb-2 text-lg">Welcome to the Demo!</h3>
                <p className="text-blue-800 mb-4">
                  You're viewing sample data from a typical Etsy store with {DEMO_ORDERS.length} orders and {DEMO_PRODUCTS.length} products. 
                  This gives you a complete preview of how your actual store data would look and work in our platform.
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <Link to="/signup">
                    <Button className="bg-blue-600 hover:bg-blue-700">
                      Sign Up to Connect Your Store
                      <ArrowRight className="ml-2 h-4 w-4" />
                    </Button>
                  </Link>
                  <Link to="/signup">
                    <Button variant="outline" className="border-blue-600 text-blue-600 hover:bg-blue-100">
                      Get Started
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Stats Grid */}
        <DashboardStats 
          stats={demoStats}
          isLoading={false}
          isConnected={true}
          formatRevenue={formatRevenue}
        />

        {/* Recent Activity - Only Recent Orders, no Quick Actions */}
        <div className="grid grid-cols-1 gap-6">
          <RecentOrders 
            recentOrders={demoStats.recentOrders}
            isConnected={true}
            isLoading={false}
            formatRevenue={formatRevenue}
          />
        </div>
      </DemoPageHeader>
    </DashboardLayout>
  );
};

export default DemoDashboard;
